import React from 'react';
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import fullLogo from '../../assets/images/logos/fulllogo_transparent.png';
import ShapeBackground from '../common/ShapeBackground';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        position: 'relative',
      }}
    >
      <ShapeBackground />
      <Container maxWidth="xs" sx={{ position: 'relative', zIndex: 1 }}>
        <Card
          sx={{
            backdropFilter: 'blur(20px)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            boxShadow: '0px 2px 24px rgba(0, 0, 0, 0.1)',
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: isMobile ? 2 : 3,
            }}
          >
            <Box
              component="img"
              src={fullLogo}
              alt="Dizpurse Logo"
              sx={{
                width: isMobile ? '200px' : '240px',
                height: 'auto',
                mb: 3,
                objectFit: 'contain',
                filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1))',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                  filter: 'drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.15))',
                },
              }}
            />

            <Typography 
              variant="body1" 
              color="text.secondary" 
              sx={{ 
                mb: 3, 
                textAlign: 'center',
                fontSize: '1rem',
                fontWeight: 500,
                letterSpacing: '0.2px',
              }}
            >
              {title}
            </Typography>

            {children}
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default AuthLayout; 